// __PKG_VERSION__ is injected at build time by tsup (see tsup.config.ts) and
// at test time by vitest (see vitest.config.ts). Both read package.json so the
// shipped VERSION never drifts from the published version.
declare const __PKG_VERSION__: string;
export const VERSION: string = __PKG_VERSION__;

export function getFrameworkName(): string {
  return 'paqad-ai';
}

export * from './adapters/index.js';
export * from './analytics/index.js';
export * from './cache/index.js';
export * from './context/index.js';
export * from './compliance/index.js';
export * from './core/index.js';
export * from './decisions/index.js';
export * from './detection/index.js';
export * from './event-bus/index.js';
export * from './design-tokens/index.js';
export * from './health/index.js';
export * from './install/index.js';
export * from './introspection/index.js';
export * from './mcp/index.js';
export * from './document/index.js';
export * from './onboarding/index.js';
export * from './packs/index.js';
export * from './pentest/index.js';
export * from './pipeline/index.js';
export * from './resolver/index.js';
export * from './rag/index.js';
export * from './scripts/index.js';
export * from './skills/index.js';
export * from './templates/index.js';
export * from './test-output/index.js';
export * from './token-efficiency/index.js';
export * from './update/index.js';
export * from './verification/index.js';
export * from './validators/index.js';
export * from './patterns/index.js';
export * from './project-knowledge/index.js';
export * from './planning/index.js';
export * from './workflows/index.js';
